'use client';

import posthog from 'posthog-js';
import { resolveEventProperties } from '../common';
import type { CaptureEventArgs } from '../capture.types';

export const captureEvent = async (args: CaptureEventArgs): Promise<void> => {
  try {
    const { event, autoProps = {} } = args;
    const resolvedProps = await resolveEventProperties(event.properties);

    posthog.capture(event.name, {
      ...autoProps,
      ...(autoProps.tenant ? { $groups: { tenant: autoProps.tenant } } : {}),
      ...resolvedProps,
    });
  } catch {
    // analytics must never throw into the caller
  }
};
